import React from 'react';

import Alert from '@amzn/meridian/alert';
import Link from '@amzn/meridian/link';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { T2_JOB_REFERENCE_CARD } from 'src/config/ExternalLinks';

const T2PlusBanner = () => {
  return (
    <Row spacingInset={'none none 400 none'} width={'fill'} alignmentHorizontal="center">
      <Alert type="theme" aria-label="T2+ Alert" width={'80%'}>
        <Text>
          Questions on Return to Work's T2+ experience? Please refer to our&nbsp;
          <Link href={T2_JOB_REFERENCE_CARD} target="_blank" rel="noopener noreferrer">
            Quick Reference Card.
          </Link>
        </Text>
      </Alert>
    </Row>
  );
};

export default T2PlusBanner;
